import { H2, H3 } from "../../components"
import SocialMediaGroup from "../socialMediaGroup"

const PersonRow = ({
	name,
	position,
	linkedIn,
	instagram,
	twitter,
	image,
	imageClassName,
}: {
	name: string
	position: string
	linkedIn?: string
	instagram?: string
	twitter?: string
	image: string
	imageClassName: string
}) => {
	return (
		<div className="flex flex-row items-center mb-7">
			<div className="w-auto md:w-3/4 flex items-center flex-col">
				<div className={`${imageClassName} bg-white rounded-full relative p-4`}>
					<video
						muted
						autoPlay
						loop
						playsInline
						className="bg-white rounded-full border-2 border-white"
						style={{
							width: "75px",
							height: "75px",
							boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.25)",
						}}
						poster={`/assets/images/${image}.jpg`}
					>
						<source src={`/assets/videos/${image}.mp4`} type="video/mp4" />
					</video>
				</div>
			</div>
			<div className="w-auto md:w-1/4 pl-4 flex flex-1 flex-col space-y-4">
				<H2>{name}</H2>
				<div className="flex flex-row justify-between items-center">
					<H3>{position}</H3>
					<SocialMediaGroup
						linkedIn={linkedIn}
						instagram={instagram}
						twitter={twitter}
					/>
				</div>
			</div>
		</div>
	)
}

export default PersonRow
